import ManualDocumentApi from "@/api/masterData/manualDocumentApi";

export default {
  namespaced: true,
  states: {},
  mutations: {},
  actions: {
    async addOrUpdate({dispatch}, {form, context}) {
      try {
        const response = await ManualDocumentApi.addOrUpdate(form, context);
        dispatch('NOTIFY_MSG', 'piglet.notification.manualDocument', {root: true});
        return Promise.resolve(response.data);
      } catch (error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async fetchById({dispatch}, {id}) {
      try {
        const response = await ManualDocumentApi.fetchById(id);
        return Promise.resolve(response.data);
      } catch (error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async printPreview({dispatch}, {id}) {
      try {
        const response = await ManualDocumentApi.preview(id);
        return Promise.resolve(response.data);
      } catch (error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async print({dispatch}, {id}) {
      try {
        const response = await ManualDocumentApi.print(id);
        return Promise.resolve(response.data);
      } catch (error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async fetchFooter({dispatch}, form) {
      try {
        const response = await ManualDocumentApi.fetchFooter(form);
        return Promise.resolve(response.data);
      } catch (error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async remove({dispatch}, {id}) {
      try {
        await ManualDocumentApi.remove(id);
        return Promise.resolve();
      } catch (error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async cancel({dispatch}, {id}) {
      try {
        await ManualDocumentApi.cancel(id);
        return Promise.resolve();
      } catch (error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    }
  }
}
